import { Routes } from '@angular/router';
import { AdminImportErrorsComponent } from './';

export const adminRoutes: Routes = [
  {
    path: 'import-errors',
    loadComponent: () => AdminImportErrorsComponent,
  },
];
